// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__+uoG9","content":"FAQ_content__MeKQx"};